import { ErrorFill16 } from 'ui/icons/aurora/16px/ErrorFill16';
import { WarningFill16 } from 'ui/icons/aurora/16px/WarningFill16';
import { SuccessFill16 } from 'ui/icons/aurora/16px/SuccessFill16';
import { BoltColor2 } from 'ui/icons/ai/BoltColor2';

export enum StatusBadgeVariants {
  DRAFT = 'draft',
  READY = 'ready',
  SCHEDULED = 'scheduled',
  RECURRING = 'recurring',
  RUNNING = 'running',
  FINISHED = 'finished',
  ABORTED = 'aborted',
  RECALL = 'recalled',
}

export enum AccessBadgeVariants {
  BOSS = 'boss',
}

export enum PlatformBadgeVariants {
  AI = 'iterable ai',
}

export enum UtilityBadgeVariants {
  POSITIVE = 'positive',
  WARNING = 'warning',
  NEGATIVE = 'negative',
}

export enum MiscBadgeVariants {
  COUNTER = 'counter',
  COUNTER_SUBTLE = 'counterSubtle',
  COUNTER_ERROR = 'counterError',
  INACTIVE = 'inactive',
  BETA = 'beta',
  NEUTRAL = 'neutral',
  INFO = 'info',
  INVERTED = 'inverted',
}

export enum ConversionBadgeVariants {
  ACTIVE = 'active',
}

export enum ExperimentBadgeVariants {
  ERRORED = 'errored',
  CANCELLED = 'cancelled',
  SENDING_TO_REMAINDER = 'sendingToRemainder',
  USER_SELECTED_WINNER = 'userSelectedWinner',
  WINNER_FOUND = 'winnerFound',
}

export enum MetaBadgeVariants {
  IN_APPEAL = 'inAppeal',
  UNKNOWN = 'unknown',
}

export enum DataSyncDestinationBadgeVariants {
  PENDING = 'pending',
  ARCHIVED = 'archived',
  ENABLED = 'enabled',
  NEEDS_REVIEW = 'needsReview',
  DISABLED = 'disabled',
}

export const BADGE_VARIANT_ICONS: Record<string, JSX.Element> = {
  [UtilityBadgeVariants.POSITIVE]: <SuccessFill16 />,
  [UtilityBadgeVariants.WARNING]: <WarningFill16 />,
  [UtilityBadgeVariants.NEGATIVE]: <ErrorFill16 />,
  [PlatformBadgeVariants.AI]: <BoltColor2 />,
};

export const BADGE_VARIANTS = {
  ...AccessBadgeVariants,
  ...ConversionBadgeVariants,
  ...ExperimentBadgeVariants,
  ...MiscBadgeVariants,
  ...PlatformBadgeVariants,
  ...StatusBadgeVariants,
  ...UtilityBadgeVariants,
  ...MetaBadgeVariants,
  ...DataSyncDestinationBadgeVariants,
};
